import React, {useCallback, useEffect, useState} from 'react';
import './App.css';


function App() {
  const [engine, setEngine] = useState<any>(null);
  const [code, setCode] = useState<string>('');
  const [content, setContent] = useState<string>('');

  useEffect(() => {
    import('mermaid').then((mermaid) => setEngine(mermaid));
  }, []);

  const updateCode = useCallback((e: any) => {
    setCode(e.currentTarget.value);
  }, []);

  useEffect(() => {
    if (engine) {
      engine.default.render('graph', code)
        .then(({svg}: any) => setContent(svg))
        .catch((error: any) => setContent(`<div>${error}</div>`));
    }
  }, [engine, code]);

  return (
    <div className="App">
      <textarea className="graphcode" rows={16} cols={40} onChange={updateCode} />
      <div dangerouslySetInnerHTML={{__html: content}}/>
    </div>
  );
}

export default App;
